export const INSIGHTS_MODAL_TYPES = {
  ADD: 'add',
  DIGEST: 'digest',
  EDIT: 'edit',
};

export const SEARCH_MODAL = {
  INSIGHTS: 'insights',
};
